// extracted by css-extract-rspack-plugin
export default {"Box":"loading-box-module__Box__v8w3p"};